<template>
    <v-content :class="`account-notification`" v-if="user" id="account-notification">
        <h2>
            <typo name="title-30-normal"> Mes Notifications </typo>
        </h2>
        <sep name="M"></sep>
        <v-card elevation="0">
            <v-card-text>
                <account-notification-general :user="user" />
                <v-divider v-if="hasSelectedConventions" class="mx-16 my-5"></v-divider>
                <account-notification-conventions v-if="hasSelectedConventions" :user="user" />
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
import AccountNotificationConventions from "./AccountNotifications/AccountNotificationConventions.vue";
import AccountNotificationGeneral from "./AccountNotifications/AccountNotificationGeneral.vue";
import Vue from "vue";
import userMixin from "src/mixins/user";
import { isArray } from "lodash";

export default Vue.extend({
    mixins: [userMixin],
    props: ["user"],
    components: {
        AccountNotificationConventions,
        AccountNotificationGeneral,
    },
    computed: {
        hasSelectedConventions() {
            return (
                isArray(this.user.selectedConventions) && this.user.selectedConventions.length > 0
            );
        },
    },
});
</script>
